import { lighten } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { TABLE_DRAWER_WIDTH } from 'const';
import { useActionCellStyles } from 'kineticUtils/styles';

export const useTableStyles = makeStyles(({ palette, spacing }) => {
  const { actionCell } = useActionCellStyles();
  const sortableBackgroundColor = lighten(palette.primary.light, 0.65);
  return createStyles({
    actionCell,
    hiddenRow: {
      display: 'none',
    },
    cursorPointer: {
      cursor: 'pointer',
    },
    sortableHeader: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: sortableBackgroundColor,
        color: `${palette.getContrastText(sortableBackgroundColor)} !important`,
        '& $sortIcon': {
          opacity: 0.5,
        },
      },
    },
    sortIcon: {
      color: 'inherit !important',
    },
    subRow: {
      border: 0,
    },
    subRowCell: {
      padding: 0,
      border: 0,
    },
    expandedSubRow: {
      borderBottom: `1px solid ${palette.grey[400]}`,
    },
    cellWithSubRow: {
      border: 0,
    },
    tableDrag: {
      '& #dragRow': {
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
      },
    },
    emptyStateTableRow: {
      height: '100%',
    },
    header: {
      fontWeight: 'bold',
    },
    minWidthCell: {
      whiteSpace: 'nowrap' as const,
      // padding: 0,
      paddingRight: spacing(2),
      paddingLeft: spacing(2),
      // must be non-0 value
      width: '1%',
    },
  });
});

export const useTableColumnsMenuStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: palette.grey['100'],
      padding: `${spacing()} ${spacing(2)}`,
    },
    drawer: {
      width: TABLE_DRAWER_WIDTH,
      overflowX: 'hidden',
      '& input': {
        boxSizing: 'content-box',
      },
      boxShadow: '-3px 1px 4px -1px rgb(0 0 0 / 36%)',
    },
    filterContainer: {
      padding: `${spacing(2)}`,
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    submitButton: {
      width: 100,
      alignSelf: 'flex-end',
      marginBottom: 20,
      marginRight: 20,
      marginTop: 10,
    },
  })
);
